import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, CardBody, Input, Label } from "reactstrap";
import { Submit } from "../../../../Constant";
import { MdDelete } from "react-icons/md";

const DefaultForm = ({ images, setImages, additionalImages, setAdditionalImages }) => {
    const handleImageChange = (e) => {
        const newFiles = Array.from(e.target.files);
        setImages((prev) => [...prev, ...newFiles]);
    };


    const removeNewImage = (index) => {
        const updatedImages = [...images];
        updatedImages.splice(index, 1);
        setImages(updatedImages);
    };

    const removeAdditionalImage = (index) => {
        const updatedAdditional = [...additionalImages];
        updatedAdditional.splice(index, 1);
        setAdditionalImages(updatedAdditional);
    };
    console.log('add', additionalImages)

    return (
        <CardBody>
            <div className="pt-3">
                <Label className="form-label">Upload Images</Label>
                <Input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageChange}
                />
                <div className="mt-3 d-flex flex-wrap gap-3">
                    {/* Previously uploaded images */}
                    {additionalImages?.map((img, i) => (
                        <div
                            key={`existing-${i}`}
                            style={{
                                position: "relative",
                                border: "2px solid #ccc",
                                borderRadius: 10,
                                width: 120,
                                height: 120,
                                padding: 4,
                                boxSizing: "border-box",
                            }}
                        >
                            <img
                                src={img.image_url}
                                alt="existing"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: 8,
                                }}
                            />
                            <MdDelete
                                onClick={() => removeAdditionalImage(i)}
                                style={{
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                    background: "#fff",
                                    borderRadius: "50%",
                                    padding: 4,
                                    cursor: "pointer",
                                    color: "red",
                                    fontSize: 24,
                                    boxShadow: "0 0 6px rgba(0,0,0,0.3)",
                                }}
                            />
                        </div>
                    ))}

                    {/* Newly uploaded images */}
                    {images.map((img, i) => (
                        <div
                            key={`new-${i}`}
                            style={{
                                position: "relative",
                                border: "2px solid #ccc",
                                borderRadius: 10,
                                width: 120,
                                height: 120,
                                padding: 4,
                                boxSizing: "border-box",
                            }}
                        >
                            <img
                                src={URL.createObjectURL(img)}
                                alt="new"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: 8,
                                }}
                            />
                            <MdDelete
                                onClick={() => removeNewImage(i)}
                                style={{
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                    background: "#fff",
                                    borderRadius: "50%",
                                    padding: 4,
                                    cursor: "pointer",
                                    color: "red",
                                    fontSize: 24,
                                    boxShadow: "0 0 6px rgba(0,0,0,0.3)",
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div className="pt-4 text-end">
                <span className="ps-2 spinner-enable">
                    <Button className="btn" type="submit">{Submit}</Button>
                </span>
            </div>
        </CardBody>
    );
};


export default DefaultForm;
